export class AlternativMottagningsplats {
    mottagningsplatsId: number;
    lagerplatsId: number;

    constructor(mottagningsplatsId: number, lagerplatsId: number) {
        this.mottagningsplatsId = mottagningsplatsId;
        this.lagerplatsId = lagerplatsId;
    }
}
